import classNames from "classnames";

import css from "../gantt.module.scss";

type ClashProps = {
  width: number;
  left: number;
  top: number;
  dayWidth: number;
  title?: string;
  className?: string;
};

export const Clash = ({ width, left, top, dayWidth, title, className }: ClashProps) => (
  <div
    title={title || "booking clash"}
    className={classNames(css.clash, className)}
    style={{
      width,
      minWidth: dayWidth,
      transform: `translate(${left}px, ${top}px)`
    }}
  />
);
